/**
 * Field-session token storage.
 *
 * The field user has no JWT — only the redemption response carries an
 * HMAC-signed `field_session_token` that authorises evidence uploads via
 * the `X-Field-Session-Token` header. Held only in memory plus
 * sessionStorage (cleared when the tab closes), never `localStorage` —
 * we don't want it persisting across sessions on a shared device.
 */
const KEY = "cvp.field_session_token";

let mem: string | null = null;

export function setFieldSessionToken(token: string | null): void {
  mem = token;
  try {
    if (token === null) globalThis.sessionStorage?.removeItem(KEY);
    else globalThis.sessionStorage?.setItem(KEY, token);
  } catch {
    /* sessionStorage may be disabled — memory is enough for the tab */
  }
}

export function getFieldSessionToken(): string | null {
  if (mem) return mem;
  try {
    mem = globalThis.sessionStorage?.getItem(KEY) ?? null;
  } catch {
    mem = null;
  }
  return mem;
}

export function clearFieldSessionToken(): void {
  setFieldSessionToken(null);
}